<template>
	<billing-layout>
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div class="card" v-if="list">
						<div class="content-default-customer" >
							<div class="card-header">
								<h5 class="card-title">
									<a href="#" @click.prevent="addBanking" class="btn btn-success"><i class="fas fa-plus"></i> Add Banking</a>
								</h5>
							</div>
							<div class="card-body">
								<table class="table table-striped table-bordered table-hover" id="tbanking">
									<thead>
										<tr>
											<th style="width:85%;padding-left:15px;"> Account Details </th>
											<th  class="text-center"style="width:5%;"> Status </th>
											<th style="width:10%;"> </th>
										</tr>
									</thead>
									<tbody v-if="isLoading"><tr><td colspan="3"><Loader></Loader></td></tr></tbody>
									<tbody v-else>
										<tr  v-for="i in bankingList" >
											<td @click="selectBanking(i.id, i.bank_name, i.account_type, i.account_number)">
												<div style="cursor: pointer;">
													<div class="icono-banking">
														<i v-if="i.account_type==1" class="fa fa-university fa-2x"></i>
														<i v-if="i.account_type==0"class="fas fa-money-check-alt fa-2x"></i>
													</div>
													<div class="details-banking">
														<strong class="text-info">{{ i.bank_name }} </strong><br>
														<small>xxxx{{ i.account_number.slice(-4) }}</small>
													</div>
												</div>
											</td>
											<td class="text-center">
												<span v-if="i.activo==1" class="badge badge-success">Active</span>
												<span v-if="i.activo==0" class="badge badge-danger">Inactive</span>
											</td>
											<td class="text-center">
												<span class="cdropdown">
													<button>Actions</button>
													<label>
														<input type="checkbox">
														<ul>
															<li @click="editBanking(i.id)"><button><i class="fas fa-edit"></i> Edit</button></li>
															<li v-if="i.activo==0" @click="activeBankin(i.id)"><button><i class="fas fa-check-square"></i> Active</button> </li>
															<li v-if="i.activo==1" @click="inactiveBankin(i.id)"><button><i class="fas fa-ban"></i> Inactive</button> </li>
														</ul>
													</label>
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="card" v-if="tablas">
						<div class="content-default-customer" >
							<div class="card-header">
								<div class="row">
	                <div class="col-6 text-left">
	                	<div>
	                		<div class="icono-banking">
	                			<i v-if="selectBank.account_type==1" class="fa fa-university fa-2x"></i>
	                			<i v-if="selectBank.account_type==0"class="fas fa-money-check-alt fa-2x"></i>
	                		</div>
	                		<div class="details-banking">
	                			<strong class="text-info" style="font-size:16px;">{{ selectBank.bank_name }} </strong>
	                			<small>xxxx{{ selectBank.account_number.slice(-4) }}</small>
	                		</div>
	                	</div>
	                </div>
	                <div class="col-6 text-right" style="margin-bottom:10px;">
	                	<button class="btn btn-info btn-sm mr-2" @click="backList()">
	                		<i class="fas fa-arrow-left"></i> Back to list
	                	</button>
	                </div>
	              </div>
							</div>
							<div class="card-body">
								<div v-if="loadingUnaccepted"><Loader></Loader></div>
								<div class="row" v-else>									
                                    <div class="col-md-12 col-md-12" style="padding-right: 30px;">
                                        <div class="row">
                                            <div class="alert alert-light col-md-4 " style="padding: 0rem 0.80rem; ">
                                                <div class="row" style="border:1px solid #ccc; padding:5px;">
                                                    <label class=" text-success col-md-3 col-sm-3 tlabel" style ="padding: 0.4em 0;">
                                                        Income:
                                                    </label>
                                                    <h3 class="col-md-9 col-sm-9  text-left" >
                                                        <span class="badge badge-light total_ipad">
                                                            ${{ totalIncome | formatMoney }}
                                                        </span>
                                                    </h3>
                                                    <div class="col-md-12" style="padding:0px;" >
                                                        <GChart :settings="{ packages: ['corechart'] }" type="AreaChart" :data="dataChartInv" :options="OpInvoicesChart"   ></GChart>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="alert alert-light col-md-4 " style="padding: 0rem 0.80rem; ">
                                                <div class="row" style="border:1px solid #ccc; padding:5px;">
                                                    <label class=" text-danger col-md-4 col-sm-3 tlabel" style ="padding: 0.4em 0;">
                                                        Expenses:
                                                    </label>
                                                    <h3 class="col-md-8 col-sm-9  text-left">
                                                        <span class="badge badge-light total_ipad">
                                                            ${{ totalExpenses | formatMoney }}
                                                        </span>
                                                    </h3>
                                                    <div class="col-md-12" style="padding:0px;" >
                                                        <GChart :settings="{ packages: ['corechart'] }" type="AreaChart" :data="dataChartExp" :options="optionsChartExp"   ></GChart>      
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="alert alert-light col-md-4 " style="padding: 0rem 0.80rem; ">
                                                <div class="row" style="border:1px solid #ccc; padding:5px;">
                                                    <label class=" text-info col-md-4 col-sm-3 tlabel" style ="padding: 0.4em 0;">
                                                        Unaccepted:
                                                    </label>
                                                    <h3 class="col-md-8 col-sm-9  text-left">
                                                        <span class="badge badge-light total_ipad">
                                                            $ {{ totalUnaccepted | formatMoney }}
                                                        </span>
                                                    </h3>
                                                    <div class="col-md-12" style="padding:0px;" >
                                                        <GChart :settings="{ packages: ['corechart'] }" type="AreaChart" :data="dataChartPro" :options="optionsChartPro"   ></GChart>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
					                <div class="col-12 ">
					                  <div class="tab-content py-0 px-3 px-sm-0" id="nav-tabContent">
					                    <div class="tab-pane fade show active " v-if="unaccepted" id="nav-unaccepted" role="tabpanel" aria-labelledby="nav-unaccepted-tab">
					                    	<div class="row">

					                    		<div class="col-sm-10 text-left">
					                    			<div class="row">
					                    				<div class="col-sm-3 text-left">
							                    			<button class="btn btn-success" style="margin-right:10px;" @click="modalTransac">
							                    				<i class="fas fa-plus"></i> Add
							                    			</button>
							                    			<span class="cdropdown">
							                    				<button class="btn btn-transaction">Import</button>
							                    				<label>
							                    					<input type="checkbox">
							                    					<ul class="text-left">
							                    						<li @click="$refs.templete.click()"><button>Import Transactions</button></li>
							                    						<li @click="downloadTemplete"><button>Download Templete</button></li>
							                    					</ul>
							                    				</label>
							                    			</span>
							                    			<input type="file" ref="templete" @change="importFile" style="display:none;">
					                    				</div>

					                    				<div class="col-sm-9 text-left">
							                    			<div class="form-inline" style="flex-wrap: nowrap;">
							                    				<div class="form-group mb-2">
							                    					<select class="form-control" v-model="SelectOne">
							                    						<option value="1">This Year</option>
							                    						<option value="2">Last Year</option>
							                    						<option value="3">This Month</option>
							                    						<option value="4">Calendar</option>
							                    						<!-- <option value="5">All</option> -->
							                    					</select>
							                    				</div>
							                    				<div class="form-group mb-2" v-if="SelectOne == 4">
							                    					<div style="display:flex;align-items: center;">
							                    						<span style="padding-right:4px;padding-left:8px;"><b>From:</b></span>
							                    						<span class="inputDateFilter">
							                    							<datetime type='date' v-model="dateFrom" format="MMM dd, yyyy" input-class="form-control" value-zone="America/New_York"></datetime>
							                    						</span>
							                    						<span style="padding-right:4px;padding-left:8px;"><b>To:</b></span>

							                    						<span class="inputDateFilter">
							                    							<datetime type='date' v-model="dateTo" format="MMM dd, yyyy" input-class="form-control" value-zone="America/New_York"></datetime>
							                    						</span>
							                    					</div>
							                    				</div>
							                    				<div class="form-group mb-2">
							                    					<label for="staticEmail2" class=""><span style="padding-left:8px;padding-right:4px;">Status: </span></label>
							                    				</div>
							                    				<div class="form-group mb-2">
							                    					<div class="basic_dropdown">
							                    						<button class="btn-status" @click="btnstatus()" style="padding: 4px 7px;">
							                    							Status <i class="fas fa-caret-down"></i>
							                    						</button>
							                    						<ul class="reset dropdStatus" v-if="statusdropd">
							                    							<li>
							                    								<div class="custom-control custom-checkbox">
							                    									<input type="checkbox" class="custom-control-input" id="check12" @click="checkAll()" v-model="isCheckAll">
							                    									<label class="custom-control-label" for="check12"><b>All</b></label>
							                    								</div>
							                    							</li>
							                    							<li v-for="(item,index) in statusdata" :key="index">
							                    								<div class="custom-control custom-checkbox">
							                    									<input type="checkbox" class="custom-control-input" :id="index" v-bind:value="item.value" v-model="statuslist">
							                    									<label class="custom-control-label" :for="index">{{item.name}}</label>
							                    								</div>
							                    							</li>                                   
							                    						</ul>
							                    					</div>
							                    				</div>
							                    				<button type="button" class="btn btn-success mb-2" @click="filtros()" style="margin-left:10px;">
							                    					<i class="fas fa-search"></i> Filter
							                    				</button>
							                    			</div>
						                    			</div>
					                    			</div>
					                    		</div>
					                    		<div class="col-sm-2 text-right">
					                    			<button class="btn btn-danger" @click="delUnaccepted">
					                    				<i class="fas fa-times"></i> Remove selected
					                    			</button>
					                    		</div>
					                    	</div>
					                    	<div class="table-unaccepted">
						                    	<table class="table table-striped table-bordered table-hover">
						                    		<thead>
						                    			<tr>
						                    				<th>Date</th>
						                    				<th>Description</th>
						                    				<th>Amount</th>
						                    				<th>Balance</th>
						                    				<th>Type</th>
						                    				<th style="text-align:center;"><input type="checkbox"  v-model="selectAll"></th>
						                    			</tr>
						                    		</thead>
						                    		<tbody>
														<tr v-if="loadingUnacceptedTable">
															<td colspan="7" style="text-align:center;"><Loader></Loader></td>
														</tr>
						                    			<tr  v-for="i in unacceptedList" v-else-if="unacceptedList.length>0">
															<td>{{ i.fecha }}</td>
															<td>{{ i.description }}</td>
															<td style="text-align: right">
																<span class="text-danger" v-if="i.textRed==1">${{ i.amount | formatMoney }}</span>
																<span class="text-success" v-else-if="i.amount > 0">${{ i.amount | formatMoney }}</span>
																<span v-else>${{ i.amount | formatMoney }}</span>
															</td>
															<td style="text-align: right">
																${{ i.balance | formatMoney }}
															</td>
															<td style="text-align:center;">
																<div v-if="i.textRed==1">
																	<span class="badge badge-danger" v-if="i.acctrans==0" @click="assingModal(i.vendor_id, i.account_id, i.id, i.description, i.amount, i.fecha, i.type)" style="background-color:#ff7500;">{{ i.account }}</span>
																	<span class="badge badge-danger" v-else>{{ i.account }}</span>
																</div>
																<div v-else-if="i.amount == 0">
																	<span class="badge badge-light">Uncategorized</span>
																</div>
																<div v-else>
																	<span class="badge badge-success">{{ i.account }}</span>
																</div>
															</td>
															<td style="text-align:center;">
																<input type="checkbox"  v-model="selected" :value="i.id" v-if="i.acctrans==0">
																<span class="badge badge-danger" v-else @click="irExpense(i.expense_id)" style="cursor:pointer;">
																	<i class="fas fa-times"></i>
																</span>
															</td>
														</tr>
														<tr v-else>
															<td colspan="6" style="text-align:center;">No record</td>
														</tr>
						                    		</tbody>
						                    	</table>
					                    	</div>
					                    </div>          
					                  </div>                
					                </div>
				              	</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal name="form-assing" height="auto" @before-close="ClosedModal">
			<div class="card">
				<div class="card-header">
					{{ modal.title }}
				</div>
				<div class="card-body" style="">
					<Loader v-if="modal.isLoading"></Loader>
					<div v-else>
						<form @submit.prevent="saveVendor" v-if="modal.vendor" >
							<div class="form-group">
								<label for="inputCity">Company Name</label>
								<input type="text" class="form-control" v-model="addVendor.company_name" required>
							</div>
							<div class="row">
								<div class="col-12 text-right">
									<button type="button" class="btn btn-secundary" @click="hideVendor" style="margin-right: 10px;">
										<i class="fas fa-times"></i> Cancel
									</button>
									<button type="submit" class="btn btn-success">
										<i class="fas fa-save"></i> Save
									</button>
								</div>
							</div>
						</form>
						<form @submit.prevent="saveAssing" v-if="modal.assing" >
							<div class="form-group col-12 backingList" style="margin:20px 0px;">
								<model-select 
								required
								:options="AccountList" 
								v-model="form.Account" 
								placeholder="Choose a Account">
								</model-select>
		                    </div>
							<div class="form-group col-12 backingList" style="margin:40px 0px 20px 0px">
								<span style="position: absolute; right: 5px; top: -21px;">
									<button type="button" class="btnlink" @click="addVendorNew">
										<i class="fas fa-plus"></i> New Vendor
									</button>
								</span>
								<model-select 
								required
								:options="VendorList" 
								v-model="form.Vendor" 
								placeholder="Choose a Vendor">
								</model-select>
							</div>
							<div class="form-group col-12">
								<label for="inputCity">Date</label>
								<datetime  input-class="form-control" required v-model="inputFechaEdit" disabled></datetime>
							</div>
							<div class="form-group col-12">
								<label for="inputCity">Amount</label>
								<input type="text" class="form-control"  required v-model="form.amount" disabled>
							</div>
							<div class="form-group col-12 " style="margin:40px 0px 50px 0px">
								<label class="control-label">
									<span class="text-dashed-underline">Description </span>
								</label> 
								<textarea class="form-control" required v-model="form.description"> </textarea>
							</div>
							<div class="col-12 text-right">
									<button type="button" class="btn btn-secundary" @click="hideModal" style="margin-right: 10px;">
										<i class="fas fa-times"></i> Cancel
									</button>
									<button type="submit" class="btn btn-success">
										<i class="fas fa-save"></i> Save
									</button>
									<button type="button" class="btn btn-danger" @click="delUnacceptedExpense(form.id)" style="margin-left: 10px;">
										<i class="fas fa-times"></i> Delete
									</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</modal>
		<modal name="form-Transac" height="auto" @before-close="ClosedModal">
			<div class="card">
				<div class="card-header">
					Add Transactions
				</div>
				<div class="card-body" style="padding-top:30px; padding-bottom:100px;">
					<Loader v-if="Transac.isLoading"></Loader>
					<div v-else>
						<form @submit.prevent="saveTransac"  >
							<div class="form-group">
								<label for="inputCity">Date</label>
								<datetime  input-class="form-control" required v-model="inputFecha"></datetime>
							</div>
							<div class="form-group " >
								<label class="control-label">
									<span class="text-dashed-underline">Type</span>
								</label>
								<select class="form-control" required v-model="Transac.type">
									<option value="1">Income</option>
									<option value="2">Unaccepted Expense </option>
								</select> 
		                    </div>
							<div class="form-group">
								<label for="inputCity">Amount</label>
								<input type="text" class="form-control"  required v-model="Transac.amount">
							</div>
							<div class="form-group-12 " style="margin:40px 0px 50px 0px">
								<label class="control-label">
									<span class="text-dashed-underline">Description </span>
								</label> 
								<textarea class="form-control" required v-model="Transac.desc"> </textarea>
							</div>
							<div class="col-12 text-right">
									<button type="button" class="btn btn-secundary" @click="hideModal" style="margin-right: 10px;">
										<i class="fas fa-times"></i> Cancel
									</button>
									<button type="submit" class="btn btn-success">
										<i class="fas fa-save"></i> Save
									</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</modal>
		<notifications group="noti" position="top center"></notifications>
	</billing-layout>
</template>

<script>
	import axios from 'axios'
	import Loader from '@/components/shared/Loader'
	import BillingLayout from '@/Layouts/Billing/BillingLayout'
	import { ModelSelect } from 'vue-search-select';
	import { GChart } from 'vue-google-charts'
	export default {
    components:{
    	Loader,
    	BillingLayout,
		ModelSelect, 
        GChart,
    },
    name: 'Banking',
    data () {
    	return {
    		isLoading : false,
    		list : true,
    		tablas : false,
    		bankingList: [],
    		unaccepted: false,
			accepted: false,
			selectBank: {
				account_type: 1,
				bank_name: '',
				account_number: '1234',
			},
			unacceptedList: [],
			acceptedList: [],
			loadingAccepted: false,
			loadingUnaccepted: false,
			loadingUnacceptedTable: false,
			modal:{
				title: '',
          		vendor: false,
          		assing: false,
          		isLoading: false,
          	},
          	VendorList: [],
          	addVendor: { company_name: null},
          	AccountList: [],
          	form: {
          		id: null,
          		Vendor: null,
				Account: null,
				description: null,
				amount: 0,
				date: new Date().toISOString().slice(0,10),
          	},
          	selected: [],
          	file: null,
          	templete: null,
          	Transac: {
          		isLoading: false,
          		banking_id: 0,
				date: new Date().toISOString().slice(0,10),
				type: 1,
				amount: 0.01,
				desc:'',
			},
            inputFecha : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
            inputFechaEdit : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
            dataChartInv:[['Invoice', 'Total']],
            OpInvoicesChart: {
                //title:'Sales & Expenses',
                legend: {position: 'none'},
                colors: ['#5ac146',],
                hAxis: {title: 'Income',  titleTextStyle: {color: '#333'}},
                tooltip: { textStyle: {fontSize: 8, color: '#333'}},
                height:'80',
                chartArea:{left:'30',top:'5',width:'80%',height:'40'},
            },
            dataChartExp:[['Expenses', 'Amount']],
            optionsChartExp: {
                //title:'Sales & Expenses',
                legend: {position: 'none'},
                colors: ['#fa5838'],
                hAxis: {title: 'Expenses',  titleTextStyle: {color: '#333'}},
                tooltip: { textStyle: {fontSize: 8, color: '#333'}},
                height:'80',
                chartArea:{left:'30',top:'5',width:'80%',height:'40'},
            },
            dataChartPro:[['Unaccepted', 'Unaccepted']],
            optionsChartPro: {
                //title:'Sales & Expenses',
                legend: {position: 'none'},
                colors: ['#0065df',],
                hAxis: {title: 'Unaccepted',  titleTextStyle: {color: '#333'}},
                tooltip: { textStyle: {fontSize: 8, color: '#333'}},
                height:'80',
                chartArea:{left:'30',top:'5',width:'80%',height:'40'},
            },
			totalIncome: 0,
			totalExpenses: 0,
			totalUnaccepted: 0,
            botonAction: [
                'Actions',
                'This Year',
                'Previous Year',
                'Last 12 Months',
                'This Month',
                'Previous Month'
            ],
            filterSelected: 1,


			statusdropd : false,
			isCheckAll: true,
			statusdata: [
             {'value' : '1','name' : 'Income'},
             {'value' : '2','name' : 'Expense'},
             {'value' : '3','name' : 'Unaccepted'},
			],
			statuslist: [1,2,3],
			showModal: false,
			SelectOne : 2,
			dateFrom : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
			dateTo : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),

    	}
    },
	created(){
		this.getBanking();
	},
    mounted(){
    },
	methods: {
			irExpense(id){
				this.$router.push({name:'ExpensesEdit', params:{ide:id}});
			},
			btnstatus(){
				this.statusdropd = !this.statusdropd;
			},
			checkAll: function(){
				this.isCheckAll = !this.isCheckAll;
				this.statuslist = [];
				if(this.isCheckAll){
					for (var key in this.statusdata) {
						this.statuslist.push(this.statusdata[key].value);
					}
				}
			},
			filtrosResumen(filter){
				this.filterSelected=filter;
				this.listResumen(this.selectBank.id, this.filterSelected);
			},
			filtros(){
				this.statusdropd =false;
				let datos = {
					id: this.selectBank.id,
					filter: this.SelectOne,
                    status: this.statuslist,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                };
                if(this.SelectOne==1){this.filtrosResumen(1);}
                if(this.SelectOne==2){this.filtrosResumen(2);}
                
				this.listTransactions(datos);
			},
			formatearFecha(){
	         this.inputFecha= new Date((new Date(this.inputFecha).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
	        },
			formatearFechaEdit(){
	         this.inputFechaEdit= new Date((new Date(this.inputFechaEdit).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
	        },
	        modalTransac(){
	        	this.$modal.show('form-Transac');	
	        },
			getBanking(){
				this.isLoading = true;
				window.billing.get('bankings/'+window.localuserdata)
				.then((response) => {
					this.isLoading = false;
					//console.log(response.data);
					this.bankingList =response.data.result;
				})
				.catch((error) => {
					this.isLoading = false;
					console.log(error);
				});
			},
			selectBanking(id, name, type, num)
			{
				this.Transac.banking_id=id;
				this.selectBank.id=id;
				this.selectBank.account_type=type;
				this.selectBank.bank_name=name;
				this.selectBank.account_number=num;
				this.list=false;
				this.tablas=true;
				this.unaccepted=true;
				this.accepted=false;
				this.filtrosResumen(this.filterSelected);
				this.filtros();


			},
			backList()
			{
				this.list=true;
				this.tablas=false;
			},
			menuTab(href){
				if(href=='nav-unaccepted'){this.unaccepted=true;this.accepted=false;}
				if(href=='nav-accepted'){this.unaccepted=false;this.accepted=true;}
			},
			addBanking(){
				this.$router.push('/billing/banking/new');
			},
			editBanking(id){
				this.$router.push('/billing/banking/new/'+id);
			},
			inactiveBankin(id){
				this.isLoading = true;
				window.billing.get('banking/void/'+id)
				.then((response) => {
					this.$notify({
						group: 'noti',
						title: 'Success',
						type: 'success',
						text: 'Successfull'
					});
				
					this.getBanking();
				})
				.catch((error) => {
					this.isLoading = false;
					console.log(error);
				});
			},
			activeBankin(id){
				this.isLoading = true;
				window.billing.get('banking/active/'+id)
				.then((response) => {
				
				 this.$notify({
						group: 'noti',
						title: 'Success',
						type: 'success',
						text: 'Successfull'
					});
					this.getBanking();
				})
				.catch((error) => {
					this.isLoading = false;
					console.log(error);
				});
			},
			listResumen(id, filtro){
				this.loadingUnaccepted = true;
				window.billing.get('banking/transacresumen/'+id+'/'+filtro)
				.then((response) => {
					let resumen= response.data.resumen;
					this.totalIncome=0;
					this.totalExpenses=0;
					this.totalUnaccepted=0;
					this.dataChartInv=[];
					this.dataChartExp=[];
					this.dataChartPro=[];
		            this.dataChartInv=[['Income', 'Total']];
		            this.dataChartExp=[['Expenses', 'Amount']];
		            this.dataChartPro=[['Unaccepted', 'Unaccepted']];
		            for (let i in resumen)
		            {
		            	this.totalIncome+=parseInt(resumen[i].income);
		            	this.dataChartInv.push([resumen[i].nom, parseInt(resumen[i].income)]);

		            	this.totalExpenses+=parseInt(resumen[i].expense);
		            	this.dataChartExp.push([resumen[i].nom, (parseInt(resumen[i].expense) *-1)]);	
		            	
		            	this.totalUnaccepted+=parseInt(resumen[i].unaccep);
		            	this.dataChartPro.push([resumen[i].nom, (parseInt(resumen[i].unaccep) *-1)]);	            
		            }
					if(isNaN(this.totalIncome)){this.totalIncome=0;}
		            if(isNaN(this.totalExpenses)){this.totalExpenses=0;}
		            if(isNaN(this.totalUnaccepted)){this.totalUnaccepted=0;}
		            if(!isNaN(this.totalUnaccepted)  && this.totalUnaccepted ==0 ){
		                this.dataChartPro.push(['', this.totalUnaccepted]);
		            }
		            if(!isNaN(this.totalIncome) && this.totalIncome ==0 )
		            {
		                this.dataChartInv.push(['', 0]);
		            }
		            if(!isNaN(this.totalExpenses) && this.totalExpenses ==0 )
		            {
		                this.dataChartExp.push(['', 0]);
		            }
					this.loadingUnaccepted = false;
				})
				.catch((error) => {
					this.loadingUnaccepted = false;
					console.log(error);
				});
			},
			listTransactions(datos){
				this.loadingUnacceptedTable = true;
				window.billing.post('banking/transac', datos)
				.then((response) => {
					//console.log(response.data.result);
					this.unacceptedList= response.data.result;
					let resumen= response.data.resumen;
					this.loadingUnacceptedTable = false;
					this.templete=response.data.template;
				})
				.catch((error) => {
					this.loadingUnacceptedTable = false;
					console.log(error);
				});
			},
	    	saveVendor(){
	    		this.modal.isLoading=true;
	    		this.modal.vendor=false;
	    		window.billing.post('expenses/vendor/add',{
                    user_id : window.localuserdata,
                    company_name : this.addVendor.company_name,
                }).then((response) => {
                	this.form.Vendor= response.data.id;
                	this.getVendors();
                	this.hideVendor();
                	this.modal.isLoading = false;
                }).catch((error) => console.log(error));
	    	},
	    	getVendors(){
	    		var self = this;
	    		this.isLoading = true;
	    		window.billing.get('vendors/'+ window.localuserdata)
	    		.then((response) => {
	    			if(response.data.success){
	    				let  Vendor = [];
	    				for(let item in response.data.result){
	    					let t = response.data.result[item].company_name;
	    					let n =response.data.result[item].firstname;
	    					if(n !=null && n!= ''){ t=t+' - '+n;}
	    					Vendor.push({
	    						value: response.data.result[item].id,
	    						text: t,
	    					}); 
	    				};
	    				self.VendorList = Vendor;
	    			}
	    			self.isLoading = false;
	    		}).catch((error) => console.log(error));
	    	},
	    	getchartaccount(type){
	    		this.modal.isLoading = true;
	    		window.billing.get('banking/account/' + window.localuserdata+'/'+type)
	    		.then((response) => {
	    			if(response.data.result.length > 0){
	    				let  AccountList = [];
	    				for(let item in response.data.result){
	    					let t = response.data.result[item].name_account;
	    					AccountList.push({
	    						value: response.data.result[item].id,
	    						text: t,
	    					}); 
	    				};
	    				this.AccountList= AccountList;
	    			}
	    			this.modal.isLoading = false
	    		}).catch((error) => console.log(error));
	    	},
	    	ClosedModal(){
	    		this.modal.title='';
	    		this.modal.vendor=false;
				this.modal.assing=false;
				this.VendorList=[];
				this.AccountList=[];
				this.inputFecha= new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
				this.Transac.date=new Date().toISOString().slice(0,10);
				this.Transac.type=1;
				this.Transac.amount=0.01;
				this.Transac.desc='';
				this.Transac.isLoading= false;
	    	},
	    	hideModal(){
	    		this.$modal.hide('form-assing');
	    		this.$modal.hide('form-Transac');
	    	},
	    	hideVendor(){
	    		this.modal.title='Assign';
	    		this.modal.vendor=false;
				this.modal.assing=true;
				this.addVendor.company_name=null;
	    	},
	    	addVendorNew(){
	    		this.$modal.show('form-assing');	    		
	    		this.modal.title='Add Vendor';
				this.modal.assing=false;
	    		this.modal.vendor=true;
				this.addVendor.company_name=null;
	    	},
	    	assingModal(vendor_id, account_id, id, description,amount, fecha, type){
	    		this.$modal.show('form-assing');	    		
	    		this.modal.title='Assing';
				this.modal.assing=true;
	    		this.modal.vendor=false;
	    		this.form.Vendor=vendor_id;
	    		console.log('vendor_id='+vendor_id);
	    		this.form.Account=account_id;
	    		this.form.id=id;
	    		this.form.type=type;
	    		this.form.description=description;
	    		this.form.amount=(amount * -1);
	    		this.inputFechaEdit=new Date(fecha).toISOString().slice(0,10);
	    		this.modal.isLoading = true;
	    		this.getVendors();
	    		this.getchartaccount(this.form.type);
	    	},	    	
	    	saveAssing(){
	    		this.modal.isLoading=true;
	    		this.modal.assing=false;
	    		if( this.form.Vendor==" " )
	    		{
	    			this.$notify({
                        group: 'noti',
                        title: 'Error',
                        type: 'error',
                        text: 'vendor is required.'
                      });
	    			this.modal.isLoading=false;
	    			this.modal.assing=true;
	    		}
	    		else
	    		{
		    		window.billing.post('banking/assing/'+window.localuserdata, this.form).then((response) => {
						 this.$notify({
							group: 'noti',
							title: 'Created',
							type: 'success',
							text: 'Created successfully'
						});
	                	this.filtros();
	                	this.filtrosResumen(this.filterSelected);
	                	this.hideModal();
	                	this.modal.isLoading = false;
	                }).catch((error) => console.log(error));
	            }
	    	},
	    	delUnacceptedExpense(id){
	    		this.selected=[id];
	    		this.delUnaccepted();
	    	},	    	
	    	delUnaccepted(){
	    		if(this.selected.length > 0)
	    		{
		    		this.$swal({
		    			title: "Delete",
		    			text: "Are you sure?",
		    			type: "warning",
		    			showCancelButton: true,
		    			confirmButtonColor: "#3085d6",
		    			confirmButtonText: "Yes, Remove!"
		    		}).then((result) => {
		    			if (result.value) {
		    				this.loadingUnaccepted = true;
		    				window.billing.post('banking/unacceptdel', 
		    					{ selected: this.selected}
		    				).then((response) => {
								 this.$notify({
									group: 'noti',
									title: 'Remove',
									type: 'success',
									text: 'Successfully eliminated'
								});
		    					this.hideModal();
	                    		this.selected=[];
	                    		this.filtros();
	                    		this.filtrosResumen(this.filterSelected);
	                    		this.loadingUnaccepted  = false;
	                    	}).catch((error) => console.log(error));
	                    }
	                });
	            }
	    	},
			importFile(event){
				if(event != undefined){
					this.loadingUnaccepted = true;
					this.file = event.target.files[0]; 
					let f = new FormData();
					f.append('import', this.file, this.file.name);
					f.append('user_id', window.localuserdata);
					f.append('banking_id', this.selectBank.id);
					f.append('type', this.selectBank.account_type);
					window.billing.post('banking/import',f).then((response) => {
						console.log('import  file test')
						console.log(response.data)

						 this.$notify({
							group: 'noti',
							title: 'Processing',
							type: 'success',
							text: 'File processed successfully'
						});
                		this.filtros();
                		this.filtrosResumen(this.filterSelected);
                		this.loadingUnaccepted = false;
                		this.$refs.templete.value = '';
                	}).catch((error) =>{
                		this.loadingUnaccepted = false;
                		this.$refs.templete.value = '';
                		console.log(error)
                	});
				}
			},
			downloadTemplete(){
				window.open(this.templete , "_blank");
			},
			saveTransac(){
				if(!Number(this.Transac.amount))
				{
					this.$notify({
						group: 'noti',
						title: 'Error',
						type: 'error',
						text: 'Amount must be greater than ZERO (0).'
					});
				}
				else if(this.Transac.amount<0){
					this.$notify({
						group: 'noti',
						title: 'Error',
						type: 'error',
						text: 'only numbers, no signs.'
					});
				}
				else
				{
					this.Transac.isLoading=true;
					window.billing.post('banking/createtransac',this.Transac)
					.then((response) => {
						 this.$notify({
							group: 'noti',
							title: 'Processing',
							type: 'success',
							text: 'File processed successfully'
						});
						this.filtros();
						this.filtrosResumen(this.filterSelected);
						this.hideModal();
						this.Transac.isLoading=false;
	            	}).catch((error) =>{
	            		this.$notify({
							group: 'noti',
							title: 'Save Error',
							type: 'error',
						});
	            		this.Transac.isLoading=false;
	            		console.log(error);
	            	});	
				}
			},
	},
	watch:{
		inputFecha: function(){
			this.formatearFecha();
			this.Transac.date =this.inputFecha;
		},
		inputFechaEdit: function(){
			this.formatearFechaEdit();
			this.form.date =this.inputFechaEdit;
		},
		dateFrom: function(){
			this.dateFrom= new Date((new Date(this.dateFrom).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
		},
		dateTo: function(){
			this.dateTo= new Date((new Date(this.dateTo).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
		}
	},
	computed: {
		selectAll: {
			get: function () {
				return this.unacceptedList ? this.selected.length == this.unacceptedList.length : false;
			},
			set: function (value) {
				var selected = [];
				if (value) {
					this.unacceptedList.forEach(function (transac) {
						selected.push(transac.id);
					});
				}
				this.selected = selected;
			}
		},
	}
	};
</script>

<style lang="scss" scoped>


#tbanking thead tr th{ font-weight: bold; }
.icono-banking{
	float:left; 
	width:100%; 
	max-width:40px; 
	height:40px; 
	display:inline-block; 
	margin-right:5px;
}
.details-banking{
	float:left; 
	width:100%; 
	max-width:180px; 
	height:40px; 
	display:inline-block;
}

nav#tablasTransac > .nav.nav-tabs{
  border: none;
  color:#000;
  background:#fff;
  border-radius:0;
}
nav#tablasTransac > div button.nav-item.nav-link,
nav#tablasTransac > div button.nav-item.nav-link.active
{
  border: none;
  padding: 10px 5px;
  color:#000;
  background:#fff;
  border-radius:0;
  border: 1px solid #ddd;
}

.tab-content{
  background: #fdfdfd;
    line-height: 25px;
    border: 0px solid #ddd;
    padding:30px 25px;
}

nav#tablasTransac > div button.nav-item.nav-link:hover,
nav#tablasTransac > div button.nav-item.nav-link:focus,
nav#tablasTransac > div button.nav-item.nav-link.active
{
  border: none;
  background: #ddd;
  color:#000;
  border-radius:0;
  transition:background 0.20s linear;
}
.table-unaccepted table { min-width: 700px;  }
.table-unaccepted table thead th{ font-weight: bold;  }
.table-unaccepted table thead th:nth-child(1), #nav-accepted table tbody td:nth-child(1){ width: 100px;  }
.table-unaccepted table thead th:nth-child(3), #nav-accepted table tbody td:nth-child(3){ width: 140px; text-align: right; }
.table-unaccepted table thead th:nth-child(4), #nav-accepted table tbody td:nth-child(4){ width: 140px;  text-align: right;}
.table-unaccepted table thead th:nth-child(5), #nav-accepted table tbody td:nth-child(5){ width: 120px; text-align: center; }
.table-unaccepted table thead th:nth-child(6), #nav-accepted table tbody td:nth-child(6){ width: 48px; text-align: center; }

.table-unaccepted table tbody tr td{font-size: 0.800rem;}
.table-unaccepted {
    height: 60vh;
    overflow-y: scroll;
}
@media(min-width: 1600px){ .table-unaccepted {height: 70vh;} }
@media(min-width: 1920px){ .table-unaccepted {height: 75vh;} }
@media(min-width: 992px){
	.backingList .ui.fluid.search.selection.dropdown .menu{ max-height: 8.02857143rem !important;}
}
@media(max-width: 1190px){.table-unaccepted {height: 80vh;  overflow-x: scroll;} }
@media(max-width: 992px){
	#nav-accepted { overflow-x: scroll;  }
	.table-unaccepted {height: 75vh;} 
	.table-unaccepted table { min-width: 700px;  }
}

@media(max-width: 767px){
	.table-unaccepted {height: 55vh;} 
}
.inputDateFilter {
	width: 120px !important; 
	border-right:1px solid #dedede; 
	overflow: hidden;
} 
</style>